export interface ICard {
  title: string;
  description?: string;
  link: string;
  imageUrl: string;
}

export const SIMPLIFIED_CARDS: ICard[] = [
  {
    title: 'Ипотечный калькулятор',
    description: 'Оцените свои финансовые возможности. Рассчитайте кредит на покупку квартиры',
    link: 'https://cian.ru/ipoteka/calculator?banner=header-calc',
    imageUrl: require('./assets/calculator.svg'),
  },
  {
    title: 'Материнский капитал',
    description:
      'От государства можно получить 453 тыс. рублей на покупку квартиры. Это ощутимая помощь. Но надо знать, как получить эти деньги. Рассказываем',
    link: 'https://cian.ru/stati-pjat-pravil-dlja-sdelok-s-matkapitalom-282810',
    imageUrl: require('./assets/matkapital.svg'),
  },
  {
    title: 'Покупаем квартиру: восемь шагов к новоселью',
    description:
      'Как выбрать правильную» квартиру, за что придется платить, на чем можно сэкономить, что проверить, чтобы вас не обманули, – рассказываем «на пальцах»',
    link: 'https://www.cian.ru/stati-pokupaem-kvartiru-vosem-shagov-k-novoselju-289247',
    imageUrl: require('./assets/buy_flat.svg'),
  },
  {
    title: 'Мифы о льготной ипотеке для семей с детьми',
    description: 'Как не получить отказ в льготном кредитовании? Развенчиваем мифы и даем советы',
    link: 'https://cian.ru/stati-mify-o-lgotnoj-ipoteke-dlja-semej-s-detmi-281609',
    imageUrl: require('./assets/myths_preferential_mortgage.svg'),
  },
  {
    title: 'Квартира или апартаменты?',
    description: 'Что важнее: цена или «прописка»? Цена или налоги? Цена или стоимость эксплуатации? Давайте посчитаем',
    link: 'https://www.cian.ru/stati-kvartira-vs-apartamenty-283190',
    imageUrl: require('./assets/flat_or_apartments.svg'),
  },
  {
    title: 'Идеальная ипотека: советы заемщикам',
    description:
      'Как не ошибиться при покупке ипотечной квартиры, грамотно выбрать банк и ловко избежать типичных банковских «ловушек»',
    link: 'https://cian.ru/stati-idealnaja-ipoteka-sovety-zaemschikam-283790',
    imageUrl: require('./assets/perfect_mortgage.svg'),
  },
  {
    title: 'Как не лишиться купленной квартиры',
    description:
      'Купить квартиру – еще не все. Важно ее потом не потерять в результате мошеннических действий. Объясняем, как защитить себя от мошенников при покупке квартиры',
    link: 'https://www.cian.ru/stati-kak-zaschitit-sebja-ot-moshennikov-pri-pokupke-kvartiry-282347',
    imageUrl: require('./assets/how_not_lose_apartment.svg'),
  },
  {
    title: 'Как найти хорошего риэлтора?',
    description: 'Кого выбрать: частного риэлтора или агентство недвижимости? Что должен уметь настоящий профессионал?',
    link: 'https://www.cian.ru/stati-kak-najti-rieltora-276539',
    imageUrl: require('./assets/good_realtor.svg'),
  },
  {
    title: 'Кому банки дают ипотеку на квартиру, а кому отказывают?',
    description: 'Поводом для отказа может быть даже причина, которая вам покажется несущественной',
    link: 'https://www.cian.ru/stati-komu-banki-dajut-ipoteku-na-kvartiru-a-komu-otkazyvajut-287274',
    imageUrl: require('./assets/myths_preferential_mortgage.svg'),
  },
  {
    title: 'Семь критериев оценки эффективной работы риэлтора',
    description:
      'Многие ожидают, что риэлтор снимет всю «головную боль» по сделке. Однако на практике это не всегда так',
    link: 'https://www.cian.ru/stati-sem-kriteriev-otsenki-effektivnoj-raboty-rieltora-286322',
    imageUrl: require('./assets/realtor_evaluation_criteria.svg'),
  },
  {
    title: 'Ипотечная квартира: как получить налоговый вычет',
    description:
      'После покупки квартиры можно вернуть до 650 тыс. рублей в семейный бюджет. Рассказываем, как это сделать',
    link: 'https://www.cian.ru/stati-ipotechnaja-kvartira-kak-poluchit-nalogovyj-vychet-277862',
    imageUrl: require('./assets/tax_deduction_how_get.svg'),
  },
];
